import React from 'react'
import { amphtml } from 'component-library/google-amp/react_amp'
import { AmpAd } from 'component-library/google-amp/components/AmpAd'
import { InnerAdProps } from 'component-library/google-amp/components/AmpAdProps'

interface InnerProps {
    layout: 'nodisplay'
}

const AmpStickyAdElement = amphtml<InnerProps>('sticky-ad')

export const AmpStickyAd: React.FC<InnerAdProps> = (props: InnerAdProps) => (
    <AmpStickyAdElement layout={'nodisplay'}>
        <AmpAd {...props} />
    </AmpStickyAdElement>
)
